import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';

import { Typography } from '@hbf/dsl';
import { useIntl } from 'ha/i18n';
import { CurrencyFormat } from '@ha/intl';
import { getCurrency, getPricingValues } from '../../reducer';
import { useAdvancedPricingCalendar } from './useAdvancedPricingCalendar';

const useStyles = makeStyles()(theme => ({
  container: {
    marginTop: theme.spacing(1.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  rentPill: {
    backgroundColor: theme.palette.grey[50],
    borderRadius: theme.spacing(8),
    padding: theme.spacing(0.5, 1.25),
  },
  rentPrice: {
    color: theme.palette.grey[600],
  },
}));

export const ListingAdvancedPricingPill = (date: Date) => {
  const { classes } = useStyles();
  const { formatCurrency } = useIntl();
  const showAdvancedPricingCalendar = useAdvancedPricingCalendar();
  const currency = useSelector(getCurrency);
  const pricingValues = useSelector(getPricingValues);
  const rent = pricingValues?.monthly
    ? pricingValues.monthly[
        `m-${(date.getMonth() + 1).toString().padStart(2, '0')}`
      ]
    : 0;
  if (!showAdvancedPricingCalendar || !rent) {
    return null;
  }

  return (
    <div className={classes.container}>
      <div className={classes.rentPill}>
        <Typography.ParagraphTitle className={classes.rentPrice}>
          {formatCurrency(
            rent,
            currency,
            CurrencyFormat.WITH_CURRENCY_SYMBOL_NO_FRACTION,
          )}
        </Typography.ParagraphTitle>
      </div>
    </div>
  );
};
